import { createSlice } from "@reduxjs/toolkit";
import { donationDifferenceAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const donationDifferenceSlice = createSlice({
  name: "donationDifference",
  initialState: data,
  reducers: {
    donationDifferenceSlice(state) {
      state.isLoading = false;
    },
    donationDifferenceSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    donationDifferenceSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    donationDifferenceSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const donationDifferenceHandler = () => async (dispatch: any) => {
  try {
    dispatch(donationDifferenceAction.donationDifferenceSlice());
    const response: any = await donationDifferenceAPI();
    dispatch(donationDifferenceAction.donationDifferenceSliceSuccess(response));
  } catch (e: any) {
    dispatch(donationDifferenceAction.donationDifferenceSliceFailure(e?.response?.data?.message));
    dispatch(donationDifferenceAction.donationDifferenceSliceReset());
  }
};
export default donationDifferenceSlice.reducer;
export const donationDifferenceAction = donationDifferenceSlice.actions;
